<div class="activity-details solo">
    <c-auto-form config="setReadConfirmation.autoFormConfig"></c-auto-form>
</div>